import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

import Home from '@/views/Home/index.vue';
import Login from '@/views/Login/index.vue';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      //病原微生物数据库
      component: Home
    },
    {
      path: '/search',
      name: 'Search',
      // 物种搜索列表
      component: Login
    },
    {
      path: '/species',
      // 分类学详情-已对接，还需要优化优化
      name: 'SpeciesDetail',
      component: () => import('@/views/SpeciesDetail/index.vue')
    },
    {
      path: '/ireceptor',
      //免疫库数据详情
      name: 'RepertoireDetail',
      component: () => import('@/views/SpeciesDetail/RepertoireDetail.vue')
    },
    {
      path: '/pathogenic',
      name: 'PathogenicMicrobeDetail',
      //病原微生物详情
      component: () => import('@/views/SpeciesDetail/PathogenicMicrobeDetail.vue')
    },
    {
      path: '/genenames',
      name: 'Genenames',
      //基因名详情-已对接，还需要优化优化
      component: () => import('@/views/SpeciesDetail/GenenamesDetail.vue')
    }
  ]
});

export default router;